import Layout from '../layout'
import List from './list'
import Editor from './editor'

const basePath = '/v-admin/crm-management/microsite'

export default {
  path: `${basePath}`,
  component: Layout,
  meta: {
    permission: ['PERM_MICROSITE_CAMPAIGN_MANAGEMANT', 'PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT'],
    titleI18nKey: 'admin.crm.menu.micrositeManagement',
    menu: {
      labelI18nKey: 'admin.crm.menu.micrositeManagement'
    }
  },
  children: [
    {
      name: 'micrositeList',
      path: '',
      component: List,
      meta: {
        titleI18nKey: 'admin.crm.title.microsite.management',
        breadcrumb: { hidden: true }
      }
    },
    {
      name: 'addMicrosite',
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        titleI18nKey: 'admin.crm.title.microsite.add'
      }
    },
    {
      name: 'editMicrosite',
      path: `${basePath}/edit/:micrositeId`,
      component: Editor,
      meta: {
        isEditMode: true,
        titleI18nKey: 'admin.crm.title.microsite.edit'
      }
    }
  ]
}
